import type { FormatMonthKeyParams } from '../types';

const formatMonthKey = ({ date }: FormatMonthKeyParams): string => {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
};

export default formatMonthKey;
